import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '../assets/logo.svg'


const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-16" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 content-center" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-8 w-8",
      src: _imports_0,
      alt: "HAL Platform"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "invisible sm:visible text-xl sr-only" }, "HAL Platform")
  ])
], -1)
const _hoisted_6 = { class: "hidden md:block" }
const _hoisted_7 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_8 = { class: "hidden md:block" }
const _hoisted_9 = {
  key: 0,
  class: "ml-4 flex items-center md:ml-6"
}
const _hoisted_10 = {
  key: 1,
  class: "ml-4 flex items-center md:ml-6"
}
const _hoisted_11 = {
  key: 1,
  type: "button",
  class: "bg-white dark:bg-dark-600 p-1 rounded-full text-gray-500 dark:text-dark-300 hover:text-gray-800 dark:hover:text-dark-100 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Login", -1)
const _hoisted_13 = {
  key: 2,
  type: "button",
  class: "bg-white dark:bg-dark-600 p-1 rounded-full text-gray-500 dark:text-dark-300 hover:text-gray-800 dark:hover:text-dark-100 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "View notifications", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "-mr-2 flex md:hidden" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_20 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" }
const _hoisted_21 = { class: "pt-4 pb-3 border-t border-gray-700" }
const _hoisted_22 = { class: "flex items-center px-5" }
const _hoisted_23 = { class: "shrink-0" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "ml-3" }
const _hoisted_26 = { class: "text-base font-medium leading-none text-gray-600 dark:text-gray-400" }
const _hoisted_27 = { class: "text-sm font-medium leading-none text-gray-500 dark:text-gray-400" }
const _hoisted_28 = {
  type: "button",
  class: "ml-auto bg-white dark:bg-gray-800 shrink-0 p-1 rounded-full text-gray-500 dark:text-gray-400 hover:text-white focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "View notifications", -1)
const _hoisted_30 = { class: "mt-3 px-2 space-y-1" }

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import {
  UserIcon,
  BellIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import ThemeSelector from "@/components/ThemeSelector.vue";
import { useUserStore } from "@/stores/UserStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {

const userStore = useUserStore();

const user = {
  name: "Patrick Glass",
  email: "pglass@swisstech.ca",
  imageUrl:
    "https://en.gravatar.com/userimage/13226765/5afa99196c0a683ef74b783601fc8080.jpeg",
};
const navigation = [
  { name: "Home", href: "/", current: true },
  { name: "Profile", href: "/profile", current: false },
  { name: "About", href: "/about", current: false },
  { name: "Contact", href: "/contact", current: false },
];
const userNavigation = [
  { name: "Your Profile", href: "/profile" },
  { name: "Settings", href: "/settings" },
  { name: "Sign out", href: "/logout" },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Disclosure), {
        as: "nav",
        class: "bg-white dark:bg-dark-600"
      }, {
        default: _withCtx(({ open }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                      return _createVNode(_component_router_link, {
                        key: item.name,
                        to: item.href,
                        class: _normalizeClass([
                      item.current
                        ? 'bg-gray-50 dark:bg-dark-500 text-gray-800 dark:text-dark-100 font-bold'
                        : 'text-gray-500 dark:text-dark-400 dark:hover:bg-dark-500 hover:text-gray-900 hover:bg-gray-100 dark:hover:text-dark-100',
                      'px-3 py-2 rounded-md text-sm font-medium',
                    ]),
                        "aria-current": item.current ? 'page' : undefined
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "aria-current"])
                    }), 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                (!_unref(userStore).isAuthenticated)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        to: "/login",
                        class: "px-3 py-2 rounded-md text-sm font-medium text-gray-500 dark:text-dark-400 dark:hover:bg-dark-500 hover:text-gray-900 hover:bg-gray-100 dark:hover:text-dark-100"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Login ")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (!_unref(userStore).isAuthenticated)
                        ? (_openBlock(), _createBlock(ThemeSelector, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_unref(userStore).isAuthenticated)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_unref(UserIcon), {
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(userStore).isAuthenticated)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_13, [
                            _hoisted_14,
                            _createVNode(_unref(BellIcon), {
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(Menu), {
                        as: "div",
                        class: "ml-3 relative"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(MenuButton), { class: "max-w-xs bg-white dark:bg-dark-700 rounded-full flex items-center text-sm focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _createElementVNode("img", {
                                  class: "h-8 w-8 rounded-full",
                                  src: user.imageUrl,
                                  alt: ""
                                }, null, 8, _hoisted_16)
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(MenuItems), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-hidden" }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userNavigation, (item) => {
                                    return _createVNode(_unref(MenuItem), {
                                      key: item.name
                                    }, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("a", {
                                          href: item.href,
                                          class: _normalizeClass([
                            active ? 'bg-gray-100' : '',
                            'block px-4 py-2 text-sm text-gray-700',
                          ])
                                        }, _toDisplayString(item.name), 11, _hoisted_17)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  }), 64))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(DisclosureButton), { class: "bg-white dark:bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-500 dark:text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    (!open)
                      ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                          key: 0,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                      : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                          key: 1,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _createVNode(_unref(DisclosurePanel), { class: "md:hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createVNode(_unref(DisclosureButton), {
                    key: item.name,
                    as: "a",
                    href: item.href,
                    class: _normalizeClass([
                item.current
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                'block px-3 py-2 rounded-md text-base font-medium',
              ]),
                    "aria-current": item.current ? 'page' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["href", "class", "aria-current"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("img", {
                      class: "h-10 w-10 rounded-full",
                      src: user.imageUrl,
                      alt: ""
                    }, null, 8, _hoisted_24)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(user.name), 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(user.email), 1)
                  ]),
                  _createElementVNode("button", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_unref(BellIcon), {
                      class: "h-6 w-6",
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userNavigation, (item) => {
                    return _createVNode(_unref(DisclosureButton), {
                      key: item.name,
                      as: "a",
                      href: item.href,
                      class: "block px-3 py-2 rounded-md text-base font-medium text-gray-500 dark:text-gray-400 hover:text-white hover:bg-gray-700"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"])
                  }), 64))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})